/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import React from "react";
import "./ErrorBody.scss";
import { ExpiryIcon } from "../assets/expiry-svg";

export const ExpiryErrorBody: React.FC = () => {
  return (
    <div className="ms-ac-referenceview-error-component-container">
      <ExpiryIcon />
      <div className="ms-ac-referenceview-error-text-container">
        <p className="ms-ac-referenceview-error-heading-text">
          Request link has expired
        </p>
        <p className="ms-ac-referenceview-error-subheading-text">
          The request link you are trying to access has expired. If you would
          still like to provide a response, please ask the candidate to resend
          the request.
        </p>
      </div>
    </div>
  );
};
